import React, { useState, useEffect } from "react";
// Import Swiper React components
import { Navigation, EffectFade, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import axios from "axios";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getContent } from "../../../utils/main";
import { motion } from "framer-motion";

export const Banner = () => {
  const navigationPrevRef = React.useRef(null);
  const navigationNextRef = React.useRef(null);
  const [sections, setSections] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const lang = useSelector((state) => state.mainSlice.lang);
  const content = useSelector((state) => state.mainSlice.content);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/turkmenistan/banner-sections/`
      )
      .then((res) => {
        setSections(res.data);
      })
      .then(() => {
        setIsLoading(false);
      });
  }, []);

  const list = {
    visible: {
      opacity: 1,
      transition: {
        type: "spring",
        when: "",
        staggerChildren: 0.5,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  };

  const item = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 50 },
  };

  return (
    <div className="banner-wrapper position-relative">
      <Swiper
        modules={[Navigation, EffectFade, Autoplay]}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        spaceBetween={0}
        slidesPerView={1}
        effect="fade"
        speed={2000}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
        }}
      >
        {isLoading === true
          ? "Loading..."
          : sections.map((section) => (
              <SwiperSlide key={section.id}>
                <div
                  className="slide-wrapper"
                  style={{
                    backgroundImage: `url(${
                      process.env.REACT_APP_API_URL + section.image
                    })`,
                    paddingTop: "60%",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    height: "100%",
                  }}
                >
                  <motion.div
                    className="overlay"
                    variants={list}
                    initial="hidden"
                    animate="visible"
                  >
                    <motion.h4
                      variants={item}
                      transition={{ duration: 0.5 }}
                      className="title d-block"
                      style={{
                        backgroundImage: `url(${
                          process.env.REACT_APP_API_URL + section.image
                        })`,
                      }}
                    >
                      {lang === "en"
                        ? section.name_en
                        : lang === "ru"
                        ? section.name_ru
                        : section.name_tm}
                    </motion.h4>
                    <motion.p
                      className="content mt-4 mb-5 text-center"
                      variants={item}
                      transition={{ duration: 0.5 }}
                    >
                      {lang === "en"
                        ? section.short_content_en
                        : lang === "ru"
                        ? section.short_content_ru
                        : section.short_content_tm}
                    </motion.p>
                    <motion.span variants={item} transition={{ duration: 0.5 }}>
                      <Link
                        to={"section/" + section.slug + "#content"}
                        state={{ section, sections }}
                        className="visit-btn"
                      >
                        {getContent(content, "See More", lang)}
                      </Link>
                    </motion.span>
                  </motion.div>
                </div>
              </SwiperSlide>
            ))}
        <div className="nav-btn prev" ref={navigationPrevRef}>
          &#8249;
        </div>
        <div className="nav-btn next" ref={navigationNextRef}>
          &#8250;
        </div>
      </Swiper>
    </div>
  );
};
